import { AirConfig } from './types/types'

export const getAirConfig = (): AirConfig => window['AirConfig']
